import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { timeout } from '@/utils/common'
import Apis from '@/Apis/_'

interface Recebido {
  id: string,
  fontePagadora: string,
  grupoRepasseNome: string,
  mesAtual: number,
  mesAnterior: number,
  ano: number,
}

interface AReceber {
  id: string,
  fontePagadora: string,
  grupoRepasseNome: string,
  mesAtual: number,
  situacaoNF: string,
}

interface Provisionado {
  id: string,
  fontePagadora: string,
  grupoRepasseNome: string,
  valor: number,
}

@Module({ namespaced: true, name: 'HomeRemuneracaoStore' })
export default class HomeRemuneracaoStore extends VuexModule {
  public recebidoTableHeader: any[] = [
    { text: 'Fonte pagadora', value: 'fontePagadora', sortable: false },
    { text: 'Grupo de repasse', value: 'grupoRepasseNome', sortable: false },
    { text: 'Mês atual', value: 'mesAtual', sortable: false },
    { text: 'Anterior', value: 'mesAnterior', sortable: false },
    { text: 'Ano', value: 'ano', sortable: false },
  ]

  public aReceberTableHeader: any[] = [
    { text: 'Fonte pagadora', value: 'fontePagadora', sortable: false },
    { text: 'Grupo de repasse', value: 'grupoRepasseNome', sortable: false },
    { text: 'Mês atual', value: 'mesAtual', sortable: false },
    { text: 'Situação NF', value: '', sortable: false },
  ]

  public provisionadosTableHeader: any[] = [
    { text: 'Fonte pagadora', value: 'fontePagadora', sortable: false },
    { text: 'Grupo de repasse', value: 'grupoRepasseNome', sortable: false },
    { text: 'Valor', value: 'valor', sortable: false },
  ]

  private recebidoDefaultData: Recebido[] = []
  private aReceberDefaultData: AReceber[] = []
  private provisionadosDefaultData: Provisionado[] = []

  public recebidoData: Recebido[] = [...this.recebidoDefaultData]
  public aReceberData: AReceber[] = [...this.aReceberDefaultData]
  public provisionadosData: Provisionado[] = [...this.provisionadosDefaultData]

  get recebidoTotal() {
    return this.recebidoData.reduce((acc, obj) => acc + obj.mesAtual, 0) || 0
  }

  get aReceberTotal() {
    return this.aReceberData.reduce((acc, obj) => acc + obj.mesAtual, 0) || 0
  }

  get provisionadosTotal() {
    return this.provisionadosData.reduce((acc, obj) => acc + obj.valor, 0) || 0
  }

  @Mutation
  setRecebidoData(value: Recebido[]) {
    this.recebidoData = value
  }

  @Mutation
  clearRecebidoData() {
    this.recebidoData = [...this.recebidoDefaultData]
  }

  @Mutation
  setAReceberData(value: AReceber[]) {
    this.aReceberData = value
  }

  @Mutation
  clearAReceberData() {
    this.aReceberData = [...this.aReceberDefaultData]
  }

  @Mutation
  setProvisionadosData(value: Provisionado[]) {
    this.provisionadosData = value
  }

  @Mutation
  clearProvisionadosData() {
    this.provisionadosData = [...this.provisionadosDefaultData]
  }

  @Action
  async getRecebimentoSummaryData() {
    try {
      // const request = {
      //   success: true,
      //   data: {
      //     recebido: [
      //       {
      //         id: '34326dd0-1801-42c0-8084-73ec9f69ff80',
      //         fontePagadora: 'APEX',
      //         grupoRepasseNome: 'Incentivo não assistencial',
      //         mesAtual: 18428.02,
      //         mesAnterior: 18511.62,
      //         ano: 146860.33,
      //       },
      //       {
      //         id: '00459917-d833-4ef4-ab06-cfa43feeaf2d',
      //         fontePagadora: 'ENTHAZE',
      //         grupoRepasseNome: 'Faturado',
      //         mesAtual: 1643.18,
      //         mesAnterior: 1232.13,
      //         ano: 20705.53,
      //       },
      //       {
      //         id: '5216300c-2510-491a-a4bc-a6dcaa44dcfd',
      //         fontePagadora: 'TRIPSCH',
      //         grupoRepasseNome: 'Faturado',
      //         mesAtual: 9317.7,
      //         mesAnterior: 8953.38,
      //         ano: 164378.12,
      //       },
      //       {
      //         id: '2d959a7c-4a47-459d-bad1-339bfa1240c3',
      //         fontePagadora: 'EXIAND',
      //         grupoRepasseNome: 'Incentivo não assistencial',
      //         mesAtual: 5582.61,
      //         mesAnterior: 4230.18,
      //         ano: 71203.96,
      //       },
      //       {
      //         id: '637c06a7-54a9-4ae9-b4e1-28b79b4aa0b0',
      //         fontePagadora: 'REMOTION',
      //         grupoRepasseNome: 'Incentivo não assistencial',
      //         mesAtual: 5805.87,
      //         mesAnterior: 10238.53,
      //         ano: 140931.26,
      //       },
      //       {
      //         id: '35243319-b30c-416a-acd9-e5980718d81b',
      //         fontePagadora: 'BLEEKO',
      //         grupoRepasseNome: 'Faturado',
      //         mesAtual: 6211.27,
      //         mesAnterior: 5830.69,
      //         ano: 84069.35,
      //       },
      //       {
      //         id: '3cab7b24-b4ca-4d6e-bbcb-e4d37340f6db',
      //         fontePagadora: 'OBLIQ',
      //         grupoRepasseNome: 'Faturado',
      //         mesAtual: 16061.66,
      //         mesAnterior: 12406.56,
      //         ano: 122594.65,
      //       },
      //       {
      //         id: 'a84f8416-6f28-4faf-b236-37f19d5b704e',
      //         fontePagadora: 'DOGSPA',
      //         grupoRepasseNome: 'Faturado',
      //         mesAtual: 19724.37,
      //         mesAnterior: 16224.89,
      //         ano: 62819.2,
      //       },
      //       {
      //         id: 'ba431c04-3fc7-42e2-ad31-16d3750a3502',
      //         fontePagadora: 'APEXTRI',
      //         grupoRepasseNome: 'Incentivo não assistencial',
      //         mesAtual: 2619.9,
      //         mesAnterior: 15591.48,
      //         ano: 137785.15,
      //       },
      //     ],
      //     aReceber: [
      //       {
      //         id: '637c06a7-54a9-4ae9-b4e1-28b99b4af0b0',
      //         fontePagadora: 'REMOTION',
      //         grupoRepasseNome: 'Incentivo não assistencial',
      //         mesAtual: 5805.87,
      //         situacaoNF: 'Pendente de nota fiscal',
      //       },
      //       {
      //         id: '35243319-b30c-416a-acd9-e5060778d81b',
      //         fontePagadora: 'BLEEKO',
      //         grupoRepasseNome: 'Faturado',
      //         mesAtual: 6211.27,
      //         situacaoNF: 'Divergente',
      //       },
      //       {
      //         id: '3cab7b24-b4ca-4d6e-bbcb-a5d37860f6db',
      //         fontePagadora: 'OBLIQ',
      //         grupoRepasseNome: 'Faturado',
      //         mesAtual: 16061.66,
      //         situacaoNF: 'Divergente',
      //       },
      //       {
      //         id: 'a84f8416-6f28-4faf-b236-37f19f2b704e',
      //         fontePagadora: 'DOGSPA',
      //         grupoRepasseNome: 'Faturado',
      //         mesAtual: 19724.37,
      //         situacaoNF: 'Pendente de nota fiscal',
      //       },
      //       {
      //         id: 'ba431c04-3fc7-42e2-ad21-16d375983502',
      //         fontePagadora: 'APEXTRI',
      //         grupoRepasseNome: 'Incentivo não assistencial',
      //         mesAtual: 2619.9,
      //         situacaoNF: 'Pendente de nota fiscal',
      //       },
      //     ],
      //     provisionados: [
      //       {
      //         id: '636c06a7-54a9-4ae9-b4e1-28b79b4af0b0',
      //         fontePagadora: 'REMOTION',
      //         grupoRepasseNome: 'Incentivo não assistencial',
      //         valor: 140931.26,
      //       },
      //       {
      //         id: '35243719-b30c-416a-acd9-e5060718d81b',
      //         fontePagadora: 'BLEEKO',
      //         grupoRepasseNome: 'Faturado',
      //         valor: 84069.35,
      //       },
      //       {
      //         id: '3cab7f24-b4ca-4d6e-bbcb-e4d37860f6db',
      //         fontePagadora: 'OBLIQ',
      //         grupoRepasseNome: 'Faturado',
      //         valor: 122594.65,
      //       },
      //       {
      //         id: 'a84f8416-6f28-4fac-b236-37f19d2b704e',
      //         fontePagadora: 'DOGSPA',
      //         grupoRepasseNome: 'Faturado',
      //         valor: 62819.2,
      //       },
      //       {
      //         id: 'ba431c04-3fc7-42e2-b421-16d3750a3502',
      //         fontePagadora: 'APEXTRI',
      //         grupoRepasseNome: 'Incentivo não assistencial',
      //         valor: 137785.15,
      //       },
      //     ],
      //   },
      // }

      // await timeout(2000)
      const request = await Apis.Legacy.RecebimentoApi.getHomeRebimento()

      this.context.commit('setRecebidoData', request.data.recebido as Recebido[] || [])
      this.context.commit('setAReceberData', request.data.aReceber as AReceber[] || [])
      this.context.commit('setProvisionadosData', request.data.provisionado as Provisionado[] || [])

      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
